const artistTypes = {
  male: 'male',
  female: 'female'
};

export default artistTypes;



// WEBPACK FOOTER //
// ./src/constants/genders.js